import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { FullPageError, FullPageLoader } from '@/components/full-page-state';
import { ROUTES } from '@/shared/config/routes';
import { identify } from '@/shared/lib/analytics';
import { useViewer } from '../hooks/use-viewer';

/** Signed-in routes. Signed out → sign in, and come back here afterwards. */
export function AuthGuard() {
  const { viewer, isLoading, error, refetch } = useViewer();
  const location = useLocation();
  const userId = viewer?.user.id;

  useEffect(() => {
    if (userId) identify(userId);
  }, [userId]);

  if (isLoading) return <FullPageLoader />;
  if (error) return <FullPageError onRetry={() => void refetch()} />;
  if (!viewer) {
    const back = `${location.pathname}${location.search}`;
    const search = back === ROUTES.OVERVIEW ? '' : `?redirect=${encodeURIComponent(back)}`;
    return <Navigate to={`${ROUTES.SIGN_IN}${search}`} replace />;
  }
  return <Outlet />;
}
